// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"a4b6032459e471a957f9","339":"01e3aa49bccd1859a908"}[chunkId] + ".js";
};